import { render, staticRenderFns } from "./margreenflow.vue?vue&type=template&id=b446e93e&scoped=true&lang=pug&"
import script from "./margreenflow.vue?vue&type=script&lang=js&"
export * from "./margreenflow.vue?vue&type=script&lang=js&"
import style0 from "./margreenflow.vue?vue&type=style&index=0&id=b446e93e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b446e93e",
  null
  
)

export default component.exports